import React from 'react';
import { CHECKOUT_URL, IMAGES } from '../utils/constants';
import { CheckIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function OfferSection() {
  const openCheckout = () => {
    window.open(CHECKOUT_URL, '_blank');
  };
  return <section className="py-20 px-4 bg-gray-50" id="offerta" data-id="element-145">
      <div className="max-w-5xl mx-auto" data-id="element-146">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-200" data-id="element-147">
          <div className="bg-blue-700 p-8 text-center relative" data-id="element-148">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 bg-red-500 text-white text-sm font-bold px-8 py-1.5 rounded-b-lg uppercase tracking-wider shadow-md" data-id="element-149">
              Sconto Speciale
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 mb-2" data-id="element-150">
              Mega-Pack Educazione Fisica
            </h2>
            <p className="text-blue-100 text-lg" data-id="element-151">
              Accesso immediato a tutto il materiale + 4 Bonus Esclusivi
            </p>
          </div>

          <div className="p-8 md:p-12 flex flex-col lg:flex-row gap-12 items-center" data-id="element-152">
            {/* Left: Image & Savings */}
            <div className="w-full lg:w-1/2 flex flex-col items-center" data-id="element-153">
              <div className="relative w-full max-w-sm flex justify-center items-end h-48 md:h-64 mb-8" data-id="element-154">
                <img src={IMAGES.tomo5} alt="Tomo 5" className="absolute w-[22%] transform -rotate-12 -translate-x-[120%] z-10 shadow-lg rounded" data-id="element-155" />
                <img src={IMAGES.tomo3} alt="Tomo 3" className="absolute w-[24%] transform -rotate-6 -translate-x-[60%] z-20 shadow-lg rounded" data-id="element-156" />
                <img src={IMAGES.tomo1} alt="Tomo 1" className="absolute w-[28%] z-30 shadow-xl rounded transform scale-110" data-id="element-157" />
                <img src={IMAGES.tomo2} alt="Tomo 2" className="absolute w-[24%] transform rotate-6 translate-x-[60%] z-20 shadow-lg rounded" data-id="element-158" />
                <img src={IMAGES.tomo4} alt="Tomo 4" className="absolute w-[22%] transform rotate-12 translate-x-[120%] z-10 shadow-lg rounded" data-id="element-159" />
              </div>

              <div className="bg-blue-50 w-full rounded-xl p-6 border border-blue-100" data-id="element-160">
                <h4 className="font-bold text-gray-900 mb-4 text-center border-b border-blue-200 pb-2" data-id="element-161">
                  Riepilogo del Valore
                </h4>
                <ul className="space-y-2 text-sm" data-id="element-162">
                  <li className="flex justify-between items-center text-gray-600" data-id="element-163">
                    <span data-id="element-164">5 Libri Completi</span>
                    <span data-id="element-165">€49,95</span>
                  </li>
                  <li className="flex justify-between items-center text-gray-600" data-id="element-166">
                    <span data-id="element-167">BONUS 1: 50 Giochi Veloci</span>
                    <span className="text-green-600 font-bold" data-id="element-168">
                      GRATIS (€7,99)
                    </span>
                  </li>
                  <li className="flex justify-between items-center text-gray-600" data-id="element-169">
                    <span data-id="element-170">BONUS 2: 30 Lezioni Complete</span>
                    <span className="text-green-600 font-bold" data-id="element-171">
                      GRATIS (€9,99)
                    </span>
                  </li>
                  <li className="flex justify-between items-center text-gray-600" data-id="element-172">
                    <span data-id="element-173">BONUS 3: Schede Valutazione</span>
                    <span className="text-green-600 font-bold" data-id="element-174">
                      GRATIS (€5,99)
                    </span>
                  </li>
                  <li className="flex justify-between items-center text-gray-600" data-id="element-175">
                    <span data-id="element-176">BONUS 4: 40 Percorsi Motori</span>
                    <span className="text-green-600 font-bold" data-id="element-177">
                      GRATIS (€7,99)
                    </span>
                  </li>
                  <li className="flex justify-between items-center font-bold text-gray-900 pt-2 border-t border-blue-200 mt-2" data-id="element-178">
                    <span data-id="element-179">Valore Totale:</span>
                    <span className="line-through text-red-500" data-id="element-180">€81,91</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Right: Pricing & CTA */}
            <div className="w-full lg:w-1/2 flex flex-col items-center text-center" data-id="element-181">
              <div className="mb-6" data-id="element-182">
                <p className="text-gray-500 text-xl mb-2" data-id="element-183">
                  Prezzo Originale:{' '}
                  <span className="line-through decoration-red-500 decoration-2" data-id="element-184">
                    €49,00
                  </span>
                </p>
                <div className="flex items-start justify-center" data-id="element-185">
                  <span className="text-3xl font-bold text-gray-900 mt-2" data-id="element-186">
                    €
                  </span>
                  <span className="text-7xl font-extrabold text-gray-900 tracking-tighter" data-id="element-187">
                    15<span className="text-5xl" data-id="element-188">,99</span>
                  </span>
                </div>
                <div className="bg-green-100 text-green-800 font-bold px-4 py-1.5 rounded-full mt-3 inline-block border border-green-200" data-id="element-189">
                  Risparmi €65,92 oggi!
                </div>
              </div>

              <div className="w-full mb-6" data-id="element-190">
                <p className="text-sm text-gray-500 font-bold uppercase mb-2" data-id="element-191">
                  L'offerta scade tra:
                </p>
                <CountdownTimer data-id="element-192" />
              </div>

              <button onClick={openCheckout} className="w-full bg-green-500 hover:bg-green-400 text-white font-extrabold text-xl py-5 px-6 rounded-full shadow-[0_8px_30px_rgb(34,197,94,0.4)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-fast mb-4 border-b-4 border-green-700" data-id="element-193">
                ACCEDI ORA AL MEGA-PACK
                <span className="block text-sm font-medium opacity-90 mt-1" data-id="element-194">
                  Solo €15,99 - Accesso Immediato
                </span>
              </button>

              <div className="flex flex-col items-center gap-3 w-full" data-id="element-195">
                <div className="flex items-center justify-center gap-2 text-gray-600 text-sm font-medium bg-gray-50 py-2 px-4 rounded-lg w-full border border-gray-100" data-id="element-196">
                  <LockIcon className="w-4 h-4 text-green-600" data-id="element-197" />
                  <span data-id="element-198">Pagamento sicuro e crittografato a 256-bit</span>
                </div>
                <div className="flex items-center justify-center gap-2 text-gray-600 text-sm font-medium bg-gray-50 py-2 px-4 rounded-lg w-full border border-gray-100" data-id="element-199">
                  <ShieldCheckIcon className="w-4 h-4 text-blue-600" data-id="element-200" />
                  <span data-id="element-201">Garanzia 7 Giorni Soddisfatti o Rimborsati</span>
                </div>

                {/* Payment Icons Placeholder */}
                <div className="flex gap-2 mt-2 opacity-60" data-id="element-202">
                  <div className="h-8 w-12 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-203">
                    VISA
                  </div>
                  <div className="h-8 w-12 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-204">
                    MC
                  </div>
                  <div className="h-8 w-12 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-205">
                    PAYPAL
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}